import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const SolicitudesClientes = () => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [solicitudesFiltradas, setSolicitudesFiltradas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filtros, setFiltros] = useState({
    estado: 'todos',
    tipo: 'todos',
    solicitante: '',
    cliente: '',
    fechaInicio: '',
    fechaFin: ''
  });
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [tiposUnicos, setTiposUnicos] = useState([]);
  const [expandirDetalles, setExpandirDetalles] = useState({});

  // Función para obtener datos de la API
  const fetchSolicitudes = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        Usr: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        DatosMetodo: {
          NombreMetodo: 'ObtenerListaSolicitudesModClientes',
          Datos_Recibidos: ''
        }
      };

      const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(requestData))}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.datos_Generados) {
        throw new Error('No se encontraron datos generados');
      }
      
      const datosGenerados = JSON.parse(data.datos_Generados);
      const solicitudesData = datosGenerados.SOLICITUDES_CAMBIOS || [];
      setSolicitudes(solicitudesData);
      
      // Extraer tipos únicos para filtro
      const tipos = [...new Set(solicitudesData.map(s => s.Tipo).filter(t => t))];
      setTiposUnicos(tipos);
      
    } catch (err) {
      setError(err.message);
      console.error('Error al obtener solicitudes:', err);
    } finally {
      setLoading(false);
    }
  };

  // Aplicar filtros
  useEffect(() => {
    let resultado = [...solicitudes];
    
    // Filtro por estado
    if (filtros.estado !== 'todos') {
      resultado = resultado.filter(s => s.Estado === filtros.estado);
    }
    
    // Filtro por tipo
    if (filtros.tipo !== 'todos') {
      resultado = resultado.filter(s => s.Tipo === filtros.tipo);
    }
    
    // Filtro por solicitante
    if (filtros.solicitante) {
      resultado = resultado.filter(s => 
        s.Solicitante?.toLowerCase().includes(filtros.solicitante.toLowerCase())
      );
    }
    
    // Filtro por cliente
    if (filtros.cliente) {
      resultado = resultado.filter(s => 
        s.Cliente?.toLowerCase().includes(filtros.cliente.toLowerCase())
      );
    }
    
    // Filtro por fecha
    if (filtros.fechaInicio) {
      resultado = resultado.filter(s => new Date(s.Fecha) >= new Date(filtros.fechaInicio));
    }
    if (filtros.fechaFin) {
      resultado = resultado.filter(s => new Date(s.Fecha) <= new Date(filtros.fechaFin));
    }
    
    setSolicitudesFiltradas(resultado);
  }, [solicitudes, filtros]);

  // Función para manejar acciones
  const handleAccion = async (solicitud, accion) => {
    try {
      const actionData = {
        "Token": "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
        "Ambiente": "DESA",
        "Dispositivo": {
          "Marca": "motorola",
          "Modelo": "moto g54 5G",
          "Version": "14",
          "McAdress": null,
          "PowerStatus": "84%",
          "WifiStatus": "Conected to iphone de Mauricio",
          "GPSStatus": "ON",
          "GPS": "-90.509232|14.5903641|0"
        },
        "User": {
          "Codigo": "123",
          "UserNickName": "MSILVESTRE"
        },
        "Metodo": {
          "NombreMetodo": "AprobarSolicitudesModClientes",
          "Datos_Recibidos": JSON.stringify({
            "CodSolicitud": solicitud.Num,
            "CodUsuario": 3,
            "TipoAprov": accion === 'aprobar' ? 'A' : 'R'
          }),
          "datos_Generados": ""
        }
      };
      
      const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(actionData)
      });
      
      const result = await response.json();
      console.log(result);
      
      const mensaje = accion === 'aprobar' 
        ? '✓ Solicitud aprobada correctamente' 
        : '✗ Solicitud rechazada correctamente';
      alert(mensaje);
      
      fetchSolicitudes();
      
    } catch (err) {
      alert(`Error: ${err.message}`);
      console.error('Error al procesar acción:', err);
    }
  };

  // Función para limpiar filtros
  const limpiarFiltros = () => {
    setFiltros({
      estado: 'todos',
      tipo: 'todos',
      solicitante: '',
      cliente: '',
      fechaInicio: '',
      fechaFin: ''
    });
  };

  // Calcular estadísticas
  const estadisticas = {
    total: solicitudes.length,
    ingresado: solicitudes.filter(s => s.Estado === 'Ingresado').length,
    aprobado: solicitudes.filter(s => s.Estado === 'Aprobado').length,
    rechazado: solicitudes.filter(s => s.Estado === 'Rechazado').length
  };

  // Obtener color según estado
  const getEstadoColor = (estado) => {
    switch(estado) {
      case 'Ingresado': return 'warning';
      case 'Aprobado': return 'success';
      case 'Rechazado': return 'danger';
      default: return 'secondary';
    }
  };

  // Formatear fecha
  const formatFecha = (fechaISO) => {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleString('es-GT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Toggle detalles de tarjeta
  const toggleDetalles = (id) => {
    setExpandirDetalles(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  useEffect(() => {
    fetchSolicitudes();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Cargando...</span>
          </div>
          <p className="text-muted">Cargando solicitudes...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger shadow-sm">
          <h5 className="alert-heading">Error al cargar las solicitudes</h5>
          <p>{error}</p>
          <hr />
          <button className="btn btn-danger" onClick={fetchSolicitudes}>
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid px-4 py-5" style={{ background: '#f8f9fa', minHeight: '100vh' }}>
      {/* Header */}
      <div className="mb-4">
        <h1 className="display-5 fw-bold mb-2" style={{ color: '#1a1a2e' }}>
          Solicitudes de Modificación
        </h1>
        <p className="text-muted">Gestión de solicitudes de cambios de clientes</p>
      </div>

      {/* Estadísticas */}
      <div className="row g-3 mb-4">
        <div className="col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Total Solicitudes</h6>
                  <h2 className="mb-0 fw-bold">{estadisticas.total}</h2>
                </div>
                <div className="bg-primary bg-opacity-10 rounded-circle p-3">
                  <span style={{ fontSize: '24px' }}>📋</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Pendientes</h6>
                  <h2 className="mb-0 fw-bold text-warning">{estadisticas.ingresado}</h2>
                </div>
                <div className="bg-warning bg-opacity-10 rounded-circle p-3">
                  <span style={{ fontSize: '24px' }}>⏰</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Barra de acciones */}
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div className="d-flex gap-2">
              <button 
                className="btn btn-primary"
                onClick={fetchSolicitudes}
              >
                🔄 Actualizar
              </button>
              <button 
                className="btn btn-outline-secondary"
                onClick={() => setMostrarFiltros(!mostrarFiltros)}
              >
                🔍 Filtros
                {Object.values(filtros).some(v => v !== 'todos' && v !== '') && 
                  <span className="badge bg-primary ms-2">Activo</span>
                }
              </button>
            </div>
            <div className="text-muted">
              <small>Mostrando {solicitudesFiltradas.length} de {solicitudes.length} solicitudes</small>
            </div>
          </div>

          {/* Panel de filtros */}
          {mostrarFiltros && (
            <div className="mt-4 pt-3 border-top">
              <div className="row g-3">
                
                <div className="col-md-3">
                  <label className="form-label fw-semibold">
                    👤 Solicitante
                  </label>
                  <input 
                    type="text"
                    className="form-control"
                    placeholder="Buscar por solicitante"
                    value={filtros.solicitante}
                    onChange={(e) => setFiltros({...filtros, solicitante: e.target.value})}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-semibold">Cliente</label>
                  <input 
                    type="text"
                    className="form-control"
                    placeholder="Buscar por cliente"
                    value={filtros.cliente}
                    onChange={(e) => setFiltros({...filtros, cliente: e.target.value})}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-semibold">
                    📅 Fecha Inicio
                  </label>
                  <input 
                    type="date"
                    className="form-control"
                    value={filtros.fechaInicio}
                    onChange={(e) => setFiltros({...filtros, fechaInicio: e.target.value})}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-semibold">
                    📅 Fecha Fin
                  </label>
                  <input 
                    type="date"
                    className="form-control"
                    value={filtros.fechaFin}
                    onChange={(e) => setFiltros({...filtros, fechaFin: e.target.value})}
                  />
                </div>
                <div className="col-md-6 d-flex align-items-end">
                  <button 
                    className="btn btn-outline-secondary"
                    onClick={limpiarFiltros}
                  >
                    Limpiar filtros
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Lista de solicitudes */}
      {solicitudesFiltradas.length === 0 ? (
        <div className="card border-0 shadow-sm">
          <div className="card-body text-center py-5">
            <span style={{ fontSize: '48px' }}>🔍</span>
            <h5 className="text-muted mt-3">No se encontraron solicitudes</h5>
            <p className="text-muted">Intenta con otros filtros o actualiza el listado</p>
            <button className="btn btn-primary" onClick={limpiarFiltros}>
              Limpiar filtros
            </button>
          </div>
        </div>
      ) : (
        <div className="row g-3">
          {solicitudesFiltradas.map((solicitud) => (
            <div className="col-12" key={solicitud.Num}>
              <div className="card border-0 shadow-sm" style={{ transition: 'all 0.3s ease' }}>
                <div className="card-body p-4">
                  {/* Cabecera de la tarjeta */}
                  <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
                    <div>
                      <h5 className="mb-1 fw-bold">
                        Solicitud #{solicitud.Num}
                      </h5>
                      <div className="d-flex gap-3 flex-wrap mt-1">
                        <small className="text-muted">
                          👤 {solicitud.Solicitante}
                        </small>
                        <small className="text-muted">
                          📅 {formatFecha(solicitud.Fecha)}
                        </small>
                      </div>
                    </div>
                    <div className="d-flex gap-2 align-items-center">
                      <span className={`badge bg-${getEstadoColor(solicitud.Estado)} d-flex align-items-center gap-1 px-3 py-2`}>
                        {solicitud.Estado === 'Ingresado' && '⏰'}
                        {solicitud.Estado === 'Aprobado' && '✓'}
                        {solicitud.Estado === 'Rechazado' && '✗'}
                        <span className="ms-1">{solicitud.Estado}</span>
                      </span>
                      {/* <button 
                        className="btn btn-sm btn-link text-secondary"
                        onClick={() => toggleDetalles(solicitud.Num)}
                      >
                        {expandirDetalles[solicitud.Num] ? '▲' : '▼'}
                      </button> */}
                    </div>
                  </div>

                  {/* Información principal */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-3">
                      <div className="bg-light rounded p-3">
                        <small className="text-muted d-block mb-1">🏢 Cliente</small>
                        <strong>{solicitud.Cliente}</strong>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="bg-light rounded p-3">
                        <small className="text-muted d-block mb-1">📝 Tipo de Solicitud</small>
                        <strong>{solicitud.Tipo}</strong>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="bg-light rounded p-3">
                        <small className="text-muted d-block mb-1">🗺️ Ruta</small>
                        <strong>{solicitud.Territorio}</strong>
                      </div>
                    </div>
                  
                  <div className="col-md-3">
                          <div className="bg-light rounded p-3">
                            <small className="text-muted d-block mb-1"> 📍 Territorio</small>
                            <strong> {solicitud.Geocerca} </strong>
                          </div>
                        </div>
                        </div>
                   <div className="row g-3">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <small className="text-muted d-block mb-1"> 📝 Datos a Modificar</small>
                            <strong>{solicitud.Datos_Mod}</strong>
                          </div>
                        </div>
                        
                        <div className="col-md-3">
                          <div className="mb-3">
                            <small className="text-muted d-block mb-1 fw-semibold">
                              👔 Autorizador
                            </small>
                            <strong>{solicitud.Autorizador || 'No asignado'}</strong>
                          </div>
                        </div>
                      </div>



                  {/* Acciones */}
                  {solicitud.Estado === 'Ingresado' && (
                    <div className="mt-3 pt-3 border-top d-flex gap-2 justify-content-end">
                      <button 
                        className="btn btn-success btn-sm px-4"
                        onClick={() => handleAccion(solicitud, 'aprobar')}
                      >
                        ✓ Aprobar
                      </button>
                      <button 
                        className="btn btn-danger btn-sm px-4"
                        onClick={() => handleAccion(solicitud, 'rechazar')}
                      >
                        ✗ Rechazar
                      </button>
                    </div>
                  )}
                  {solicitud.Estado !== 'Ingresado' && (
                    <div className="mt-3 pt-3 border-top text-end">
                      <span className="text-muted small">
                        Solicitud {solicitud.Estado.toLowerCase()}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <style>{`
        .card {
          transition: all 0.3s ease;
        }
        .card:hover {
          transform: translateY(-2px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
        }
        .bg-opacity-10 {
          --bs-bg-opacity: 0.1;
        }
      `}</style>
    </div>
  );
};

export default SolicitudesClientes;